import { useState, useEffect, useRef } from 'react';
import { solicitudesApi } from '../../services/api';
import { getSocket } from '../../services/socket';

import { Solicitud } from '../../objetos/Solicitud/objeto_solicitud';

import { useUsers } from '../../metodos/userContext';
import { useConfiguracion } from '../../metodos/ConfiguracionContext';
import { useDetalleSolicitudModel } from './modeloSolicitud';

export const useSolicitudesDisponiblesModel = () => {
  const [solicitudesDisponibles, setSolicitudesDisponibles] = useState([]);
  const [solicitudesPorCliente, setSolicitudesPorCliente] = useState([]);
  const [loadingSolicitudes, setLoading] = useState(true);
  const [errorSolicitudes, setError] = useState(null);
  //cargar usuario
  const {usuario } = useUsers();

  const solicitudesCacheRef = useRef(new Map());
  const servicioAMapeo = {
    'PARCIAL': '1. Realizacion de examenes / quices',
    'QUIZ': '1. Realizacion de examenes / quices',
    'TALLER': '2. Realizacion de trabajos',
    'CLASES PERSONALIZADAS': '4. Realizacion de clases virtuales',
    'TESIS': '3. Realizacion de Tesis'
  };
  const isAdminMode = (usuario.rol == "ADMIN" || usuario.rol == "COLABORADOR") ? true : false;
  const { configuracion } = useConfiguracion();
  //NORMALIZAR IDS, ESTO SE HACE PARA DUFY ASESORIAS CON DUFY_ASESORIAS
  const normalizarId = (id, empresaId = 'primary') => {

    if (id.includes('_')) return id;
    return `${empresaId}_${id}`;

  };

  //descargar solicitud
  const {
    cargarSolicitudPorId,
  } = useDetalleSolicitudModel();

  //FILTRAR SOLICITUDES PARA ADMIN Y TUTORES
  //TUTORES : SOLO PUEDEN ACCEDER A LOS SERVICIOS QUE TIENEN
  //ADMIN : SERVICIOS DE SU EMPRESA, NOMBRE EMPRESA Y REFERIDO POR
  const filtrarSolicitudes = (solicitudesArray) => {
    console.log("configuracion",configuracion);
    console.log("usuario",usuario);
    
    if (!configuracion) {
        console.error("❌ configuracion es null o undefined");
        return [];
    }

    if (!solicitudesArray || !Array.isArray(solicitudesArray)) {
      console.error("❌ solicitudesArray no es válido:", solicitudesArray);
      return [];
    }

    if (isAdminMode) {
        console.log("👑 Vista de administrador - Mostrando todas las solicitudes:", solicitudesArray);
        const disponiblesAdminMode = [];
        
        
        solicitudesArray.forEach(solicitud => {
          console.log("tenemos cargados ","solicitud",solicitud.nombreEmpresa,"configuracion",configuracion.nombreEmpresa)
          if (solicitud.nombreEmpresa === configuracion.nombreEmpresa || solicitud.referidoPor === configuracion.nombreEmpresa){
            disponiblesAdminMode.push(solicitud);
          }

        });
        

        return disponiblesAdminMode;
    }
    
    const nombreTutor = usuario?.nombrewhatsapp;
    const materiasActivas = usuario?.materias.filter(m => m.materiaActiva) || [];
    const serviciosManejadosTutor = usuario?.tipoServicios || [];
    const fechaPresente = new Date();

    // Array para almacenar solicitudes disponibles
    const disponibles = [];

    // Clasificar las solicitudes
    solicitudesArray.forEach(solicitud => {
      // Verificar si el tutor ya cotizó esta solicitud
      const tutorHaCotizado = solicitud.cotizaciones?.some(
        cotizacion => cotizacion.nombretutor === nombreTutor
      ) || false;
      

      // Verificación de materia
      const materiaOriginalCoincide = materiasActivas.some(
        materia => materia.nombremateria === solicitud.materia
      );

      const materiaIACoincide = solicitud.predicionesIA?.materiaIA && materiasActivas.some(
        materia => materia.nombremateria === solicitud.predicionesIA.materiaIA
      );

      const materiaCoincide = materiaOriginalCoincide || materiaIACoincide;

      // Verificación de fecha de entrega
      const fechaEntrega = new Date(solicitud.fechaentrega || solicitud.fechaEntrega);
      const fechaEntregaValida = !isNaN(fechaEntrega) && fechaEntrega > fechaPresente;


      // Verificación de servicio
      const servicioMapeado = servicioAMapeo[solicitud.Servicio];
      const isServicioManejado = servicioMapeado && serviciosManejadosTutor.includes(servicioMapeado);

      //es un servicio visible
      const isVisible = !solicitud.noVisible; //si es true no es visible


      // Solicitudes válidas para el tutor según su perfil
      const esValidaParaTutor = materiaCoincide && fechaEntregaValida && isServicioManejado && isVisible;

      if (esValidaParaTutor && !tutorHaCotizado) {
        disponibles.push(solicitud);
      }
    });

    console.log("Solicitudes disponibles despues de filtrado:", disponibles.length);
    return disponibles;
  };

  //ACTUALIZAR SOLICITUDES
  const actualizarSolicitudesFiltradas = () => {

    if (!usuario) {
      setSolicitudesDisponibles([]);
      setError("No hay información de usuario disponible");
      return;
    }
    
    // Obtener array de solicitudes del Map de caché
    const todasLasSolicitudes = Array.from(solicitudesCacheRef.current.values());
    
    const solicitudesFiltradas = filtrarSolicitudes(todasLasSolicitudes);
    setSolicitudesDisponibles(solicitudesFiltradas);
  };
  //PROCESAMINETO DE SOLICIUTDES, ESTO SE HACE PARA NO TENER ERRORES
  const procesarSolicitudes = (data) => {
    // Si es un objeto de solicitudes individuales (formato API)
    if (typeof data === 'object' && data !== null) {
      let contador = 0;
      
      // Iterar sobre las entradas del objeto
      Object.entries(data).forEach(([id, solicitudData]) => {
        try {
          // Extraer información de empresa si está en formato global
          let empresaId = 'primary';
          let originalId = id;
          
          if (id.includes('_')) {
            [empresaId, originalId] = id.split('_');
          }
          
          // Asegurarse de que la información de empresa esté presente
          const dataCompleto = {
            ...solicitudData,
            empresaId: solicitudData.empresaId || empresaId,
            originalId: solicitudData.originalId || originalId,
            // Normalizar el nombre de empresa si es necesario
            nombreEmpresa: solicitudData.nombreEmpresa || 'DUFY ASESORIAS'
          };
          
          // Normalizar el ID para asegurar consistencia
          const globalId = normalizarId(id, empresaId);
          
          // Crear objeto de solicitud y guardarlo en el caché
          const solicitudObj = Solicitud.fromJson(dataCompleto, globalId);
          solicitudesCacheRef.current.set(globalId, solicitudObj);
          contador++;
        } catch (e) {
          console.error(`Error al procesar solicitud ${id}:`, e);
        }
      });
      
      console.log(`${contador} solicitudes añadidas/actualizadas en el caché`);
      return true;
    }
    
    return false;
  };

  //CARGAR SOLICITUDES
  const cargarSolicitudes = async () => {
    try {
      setLoading(true);
      // Cargar solicitudes de la API
      const response = await solicitudesApi.getSolicitudesDisponibles();

      if (!response) {
        throw new Error("No se recibió respuesta de la API");
      }

      // Determinar si los datos están en response.data o directamente en response
      const data = response;
      
      console.log("se obtiene solicitudes", Object.keys(data).length);
      console.log("response",response);

      
      // Limpiar caché antes de cargarlo de nuevo
      solicitudesCacheRef.current.clear();
      
      const procesoExitoso = await procesarSolicitudes(data);
      
      if (procesoExitoso) {
        // Actualizar las solicitudes filtradas
        await actualizarSolicitudesFiltradas();
        setError(null);
      } else {
        throw new Error("Formato de respuesta inesperado");
      }
    } catch (error) {
      console.error("Error detallado:", error);
      setError(error.message || "Error al cargar solicitudes");
    } finally {
      setLoading(false);
    }
  };

  //cargar solicitudes de cliente
  const cargarSolicitudesDeCliente = async(nombreEmpresa,numeroCliente) =>{
    try{
      setLoading(true);
      const data = await solicitudesApi.getSolicitudesCliente(nombreEmpresa,numeroCliente);
      const dataConvertida = Object.values(data);


      const solicitudesObj = dataConvertida.map(item => Solicitud.fromJson(item));

      setSolicitudesPorCliente(solicitudesObj);
      setError(null);
      return solicitudesObj;
    }
    catch(error){
      console.error("Error al obtener las solicitudes:", error);
      setError(error.message || "Error al cargar las solicitudes del cliente");
      return null;
    }
    finally{
      setLoading(false);
    }
  };

  //WEBHOOK
  const setupWebSocketsSolicitudes = (numeroCliente = 0) => {
    console.log("configurando sockets y empezando");
    const socket = getSocket();

    if (!socket) {
      console.warn("Socket no conectado, no se pueden configurar listeners.");
      return () => {}; // Devuelve una función de limpieza vacía
    }
    
    // Escuchar actualizaciones de solicitudes
    console.log("conectandos a disponble room");
    socket.emit('join-disponibles-room');

    if(numeroCliente != 0){
      socket.emit('join-clientes-room', numeroCliente);
    }

    //actualizar solicitud
    const handleUpdateNotificacion = async(data) =>{
      const globalId = data.id;
      if (!globalId) return;

      console.log(`Socket 📨: Notificación recibida para ${globalId} (Tipo: ${data.type})`);

      const [nombreEmpresa, id] = globalId.split('_');
      if (!id || !nombreEmpresa) {
        console.error(`globalId mal formado, no se puede recargar: ${globalId}`);
        return;
      }

      const datosSolicitudCompletos = await solicitudesApi.getSolicitudPorId(id,nombreEmpresa);
      const solicitudActualizada = Solicitud.fromJson(datosSolicitudCompletos, globalId);
      solicitudesCacheRef.current.set(globalId, solicitudActualizada);

      console.log(`Socket ✅: Solicitud actualizada en caché: ${globalId}`);

      actualizarSolicitudesFiltradas();

      if (numeroCliente != 0) {
        setSolicitudesPorCliente(prevSolicitudes => {
          const index = prevSolicitudes.findIndex(s => s.globalId === globalId);
          if (index > -1) {
            // Reemplaza la existente
            const nuevasSolicitudes = [...prevSolicitudes];
            nuevasSolicitudes[index] = solicitudActualizada;
            return nuevasSolicitudes;
          }
          // Si es nueva y no estaba, añádela
          if (data.type === 'added') {
            return [...prevSolicitudes, solicitudActualizada];
          }
          return prevSolicitudes;
        });
      }

    }

    const handleDeleteNotificacion = async(data) =>{
      const globalId = normalizarId(data.id, data.source);
      console.log(`Socket 🗑️: Eliminando solicitud: ${globalId}`);

      solicitudesCacheRef.current.delete(globalId);
      actualizarSolicitudesFiltradas();

      if (numeroCliente != 0) {
        setSolicitudesPorCliente(prev => prev.filter(s => s.globalId !== globalId));
      }
    }
   
    socket.on('solicitudes:disponibles', handleUpdateNotificacion);
    socket.on('solicitudes:lista_cliente_actualizada', handleUpdateNotificacion);

    socket.on('solicitudes:delete', handleDeleteNotificacion); // (Asegúrate que el nombre coincida)
    
    // Función de limpieza para cuando el componente se desmonte
    return () => {
      console.log("Limpiando listeners de solicitudes...");

      socket.emit('leave-disponibles-room');
      if (numeroCliente != 0) {
        socket.emit('leave-clientes-room', numeroCliente);
      }

      socket.off('solicitudes:disponibles', handleUpdateNotificacion);
      socket.off('solicitudes:lista_cliente_actualizada', handleUpdateNotificacion);
      socket.off('solicitudes:delete', handleDeleteNotificacion);


    };
  };

  return {
    solicitudesDisponibles,
    solicitudesPorCliente,
    loadingSolicitudes,
    errorSolicitudes,
    setupWebSocketsSolicitudes,
    cargarSolicitudes,
    cargarSolicitudesDeCliente,
  };
};